/* OMY gift guides: finder tabs, hero sparkles, scroll reveal. Safe to load more than once. */
(function () {
  if (window.__giftGuide) return; window.__giftGuide = true;
  document.documentElement.classList.add('gg-js');
  function init() {
    document.querySelectorAll('.gift-guide .finder').forEach(function (f) {
      var tabs = f.querySelectorAll('.tab');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t); });
          f.querySelectorAll('.panel').forEach(function (p) { p.classList.toggle('on', p.id === t.getAttribute('aria-controls')); });
        });
      });
    });
    document.querySelectorAll('.gift-guide .sparks').forEach(function (sp) {
      if (sp.childElementCount) return;
      for (var i = 0; i < 22; i++) {
        var s = document.createElement('i'); s.className = 'spark';
        s.style.left = (Math.random() * 100) + '%'; s.style.top = (Math.random() * 100) + '%';
        s.style.animationDelay = (-Math.random() * 3.6) + 's'; s.style.animationDuration = (2.8 + Math.random() * 2.4) + 's';
        sp.appendChild(s);
      }
    });
    var els = document.querySelectorAll('.gift-guide .rv');
    var showAll = function () { els.forEach(function (e) { e.classList.add('in'); }); };
    // theme editor or no observer support: show everything, no animation
    if ((window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) { showAll(); return; }
    var fired = false;
    var io = new IntersectionObserver(function (es) {
      fired = true;
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
    // safety net: if the observer never reports (some embedded frames), never leave content hidden
    setTimeout(function () { if (!fired) showAll(); }, 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // theme editor: re-run when a section is re-rendered
  document.addEventListener('shopify:section:load', function () { window.__giftGuideInit && window.__giftGuideInit(); });
  window.__giftGuideInit = init;
})();
